module.exports = __webpack_public_path__ + "51a17fdc3125ea48893acce026378795.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/BeerCard/images/ireland-exclusive.png
// module id = CAG/
// module chunks = 0